import { render } from "./ShareMyResults.vue?vue&type=template&id=7008a8f7"
import script from "./ShareMyResults.vue?vue&type=script&lang=js"
export * from "./ShareMyResults.vue?vue&type=script&lang=js"

import "./ShareMyResults.vue?vue&type=style&index=0&id=7008a8f7&lang=scss"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__